import * as React from "react";
import { ScrollView } from "react-native";

import MoveComponents from "../components/move";
import Layout from "../components/common/Layout";
import CreateOrUpdateMove from "../components/move/CreateOrUpdateMove";
import AppContext from "../app-context/AppContext";

function MovesScreen() {
  return (
    <Layout.Column greedy>
      <ScrollView>
        <MoveComponents.Grid emptyText="Press 'Create Move' to add a move" />
      </ScrollView>
    </Layout.Column>
  );
}

export default MovesScreen;
